import  useNavigation from '../../../hooks/useNavigation.js'
import StatusBadge from '../../common/helper/transaction-status.component.js';

export const cashoutColumns = (download) => {
    const { navigateTo } = useNavigation();

    return [
        {
          name: 'Batch Code',
          cell: row => <div className="custom-cell-merchant_name">{row.batch_code}</div>,
    
          sortable: true,
        },
        // {
        //   name: 'File',
        //   selector: row => row.file_name || '-',
        //   sortable: true,
        // },
        {
          name: 'Record Count',
          selector: row => row.record_count,
          sortable: true,
        },
        {
          name: 'Record Amount',
          cell: row => <div className="custom-cell-email_address">{ '₹' + row.record_amount}</div>,
          sortable: true,
        },
        {
          name: 'Pending Count',
          selector: row =>  row.pending_count,
          sortable: true,
        },
        {
          name: 'Pending Amount',
          selector: row =>  row.pending_amount,
          sortable: true,
        },
        {
          name: "Status",
          button: true,
          selector: row =>  row.status,
        
          cell: row =>
          <>
          
          <StatusBadge status={row.status} />
          </>
          // cell: row =>
          //  <>
          //     <span className="mgh">
          //       <img style={{width: '15px'}} src="https://cdn-icons-png.flaticon.com/512/1011/1011500.png" />
          //     </span>
          //     </>
       
        },
        {
            name: 'Start Date',
            selector: row =>  <div className="custom-cell-order_Code">{row.start_date}</div>,
            sortable: true,
          },
          {
            name: 'Finish Date',
            selector: row =>  row.finish_date || '-',
            sortable: true,
          },
       
        {
          name: "Actions",
          button: true,
          style: row => ({ zIndex:0 }),
          cell: row =>
           <>
           <a className="fview tooltip" style={{'cursor':'pointer'}}  onClick={() => download( row.batch_id)}>
             <i className="fa fa-download"  style={{color:'black'}}/>
              <span className="tooltiptext">download</span>
            </a>
                 <a className="fview tooltip" style={{'cursor':'pointer'}}  onClick={() => navigateTo('viewCashout','view-cashout', row.batch_id)}>
             <i className="fa fa-eye" />
              <span className="tooltiptext">View</span>
            </a>
            
              <a className={`fview tooltip`} style={{'cursor':'pointer'}}  onClick={() => navigateTo('uploadBatch','upload-batch',row.batch_id)}>
                <i  className={`fa fa-upload`}  style={{color:'black'}} />
                <span className="tooltiptext">Upload</span>
              </a>
              {/* <a className="ftrash tooltip" style={{'cursor':'pointer'}}>
                <i className="fa fa-trash"  style={{color:'black'}}  onClick={() => deleteMerchant(row)}/>
                <span className="tooltiptext">Delete</span>
              </a> */}
            
              </>
       
        }
      ]
  }